/* ══════════════════════════════════════════════════════════
   FUNDAÇÃO NGANA ZENZA PARA O DESENVOLVIMENTO COMUNITÁRIO
   Dados reais — actualizar imagens/vídeos com URLs reais
   ══════════════════════════════════════════════════════════ */

export const foundation = {
  name_pt: 'Fundação Ngana Zenza para o Desenvolvimento Comunitário',
  name_en: 'Ngana Zenza Foundation for Community Development',
  short_pt: 'Fundação Ngana Zenza',
  short_en: 'Ngana Zenza Foundation',
  acronym: 'FDC',
  founded: '20 de Fevereiro de 2020',
  founded_en: '20 February 2020',
  founder_pt: 'Ana Dias Lourenço, Primeira-Dama da República de Angola',
  founder_en: 'Ana Dias Lourenço, First Lady of the Republic of Angola',
  name_origin_pt: 'O nome "Ngana Zenza" homenageia Isabel "Ngana Zenza", mãe da Primeira-Dama, símbolo de solidariedade, humanidade e compromisso com o próximo.',
  name_origin_en: 'The name "Ngana Zenza" honours Isabel "Ngana Zenza", mother of the First Lady, a symbol of solidarity, humanity and commitment to others.',
  mission_pt: 'Promover o desenvolvimento humano e comunitário sustentável, através da implementação de programas sociais que contribuam para a melhoria da qualidade de vida das populações vulneráveis em Angola.',
  mission_en: 'Promote sustainable human and community development, through the implementation of social programmes that contribute to improving the quality of life of vulnerable populations in Angola.',
  vision_pt: 'Ser uma referência nacional e internacional em desenvolvimento comunitário, inclusão social e promoção da dignidade humana.',
  vision_en: 'To be a national and international reference in community development, social inclusion and promotion of human dignity.',
  email: 'geral@nganazenza.org',
  phone: '+244 923 000 000',
  address: 'Luanda, Angola',
  website: 'www.nganazenza.org',
};

export const values = [
  { pt: 'Solidariedade', en: 'Solidarity', icon: '🤝' },
  { pt: 'Humanismo', en: 'Humanism', icon: '❤️' },
  { pt: 'Inclusão Social', en: 'Social Inclusion', icon: '🌍' },
  { pt: 'Responsabilidade Comunitária', en: 'Community Responsibility', icon: '🏘️' },
  { pt: 'Sustentabilidade', en: 'Sustainability', icon: '🌱' },
  { pt: 'Transparência', en: 'Transparency', icon: '🔍' },
  { pt: 'Empoderamento Feminino e Juvenil', en: 'Female & Youth Empowerment', icon: '💪' },
  { pt: 'Respeito pela Dignidade Humana', en: 'Respect for Human Dignity', icon: '🙏' },
  { pt: 'Desenvolvimento Participativo', en: 'Participatory Development', icon: '🎯' },
];

export const areas = [
  { pt: 'Saúde', en: 'Health', icon: '🏥' },
  { pt: 'Educação', en: 'Education', icon: '📚' },
  { pt: 'Desenvolvimento Comunitário', en: 'Community Development', icon: '🏘️' },
  { pt: 'Desenvolvimento Rural', en: 'Rural Development', icon: '🌾' },
  { pt: 'Agricultura', en: 'Agriculture', icon: '🌱' },
  { pt: 'Nutrição', en: 'Nutrition', icon: '🥗' },
  { pt: 'Água e Saneamento', en: 'Water & Sanitation', icon: '💧' },
  { pt: 'Empoderamento Feminino', en: 'Female Empowerment', icon: '👩' },
  { pt: 'Juventude', en: 'Youth', icon: '🎓' },
  { pt: 'Assistência Social', en: 'Social Assistance', icon: '🤲' },
  { pt: 'Sustentabilidade Ambiental', en: 'Environmental Sustainability', icon: '♻️' },
];

export const programmes = [
  {
    id: 'pdic',
    acronym: 'PDIC',
    title_pt: 'Programa de Desenvolvimento Integrado Comunitário',
    title_en: 'Integrated Community Development Programme',
    subtitle_pt: 'Transformação comunitária sustentável e participativa',
    subtitle_en: 'Sustainable and participatory community transformation',
    desc_pt: 'O PDIC é um programa estruturante da Fundação, criado para promover o desenvolvimento integrado e sustentável das comunidades rurais em Angola. O projecto piloto foi implementado na comunidade do Toco, província da Huíla.',
    desc_en: 'The PDIC is a key programme of the Foundation, created to promote integrated and sustainable development of rural communities in Angola. The pilot project was implemented in the Toco community, Huíla province.',
    province_pt: 'Huíla (Toco)',
    province_en: 'Huíla (Toco)',
    category: 'community',
    color: 'orange',
    actions_pt: [
      'Construção e reabilitação de infra-estruturas sociais',
      'Criação de sistemas de abastecimento de água',
      'Feiras de saúde comunitária',
      'Formação técnico-profissional',
      'Assistência médica itinerante',
      'Distribuição de sementes e árvores frutíferas',
      'Campanhas de higiene e saneamento',
    ],
    actions_en: [
      'Construction and rehabilitation of social infrastructure',
      'Creation of water supply systems',
      'Community health fairs',
      'Technical and professional training',
      'Itinerant medical assistance',
      'Distribution of seeds and fruit trees',
      'Hygiene and sanitation campaigns',
    ],
    areas_pt: ['Saúde', 'Educação', 'Agricultura', 'Água', 'Saneamento', 'Nutrição', 'Sustentabilidade'],
    areas_en: ['Health', 'Education', 'Agriculture', 'Water', 'Sanitation', 'Nutrition', 'Sustainability'],
  },
  {
    id: 'tata',
    acronym: 'Tata Uhayele',
    title_pt: 'Tata Uhayele – Cuide da Sua Saúde',
    title_en: 'Tata Uhayele – Take Care of Your Health',
    subtitle_pt: 'Saúde acessível às populações mais carenciadas',
    subtitle_en: 'Healthcare accessible to the most disadvantaged populations',
    desc_pt: 'Iniciativa de promoção da saúde comunitária que leva assistência médica e acções de sensibilização às populações mais vulneráveis, sobretudo em zonas rurais e de difícil acesso. Trabalha na prevenção, diagnóstico precoce e educação para a saúde.',
    desc_en: 'Community health promotion initiative that brings medical assistance and awareness actions to the most vulnerable populations, especially in rural and hard-to-reach areas. Focuses on prevention, early diagnosis and health education.',
    category: 'health',
    color: 'red',
    actions_pt: ['Consultas médicas', 'Rastreios', 'Educação sanitária', 'Saúde preventiva', 'Campanhas de vacinação', 'Saúde materno-infantil'],
    actions_en: ['Medical consultations', 'Screenings', 'Sanitary education', 'Preventive health', 'Vaccination campaigns', 'Maternal and child health'],
    areas_pt: ['Saúde', 'Prevenção', 'Diagnóstico', 'Educação Sanitária'],
    areas_en: ['Health', 'Prevention', 'Diagnosis', 'Sanitary Education'],
  },
  {
    id: 'geracao',
    acronym: 'GSS2030',
    title_pt: 'Geração Sem Sida até 2030',
    title_en: 'Generation Without AIDS by 2030',
    subtitle_pt: 'Sensibilização e mobilização social contra o VIH/SIDA',
    subtitle_en: 'Social awareness and mobilisation against HIV/AIDS',
    desc_pt: 'Programa de sensibilização e mobilização social criado para contribuir para a redução do VIH/SIDA em Angola. Promove educação comunitária, prevenção e combate ao estigma social associado à doença.',
    desc_en: 'Social awareness and mobilisation programme created to contribute to reducing HIV/AIDS in Angola. Promotes community education, prevention and fighting the social stigma associated with the disease.',
    category: 'health',
    color: 'red',
    actions_pt: ['Sensibilização de jovens e famílias', 'Testagem voluntária', 'Incentivo à prevenção', 'Combate a preconceitos', 'Educação sexual responsável'],
    actions_en: ['Awareness for youth and families', 'Voluntary testing', 'Prevention incentives', 'Fighting prejudice', 'Responsible sexual education'],
    areas_pt: ['Saúde', 'Educação', 'Juventude', 'Inclusão Social'],
    areas_en: ['Health', 'Education', 'Youth', 'Social Inclusion'],
  },
  {
    id: 'seja-mulher',
    acronym: 'Seja Mulher',
    title_pt: 'Seja Mulher',
    title_en: 'Be a Woman',
    subtitle_pt: 'Empoderamento, autonomia e valorização da mulher angolana',
    subtitle_en: 'Empowerment, autonomy and valorisation of Angolan women',
    desc_pt: 'Programa de empoderamento feminino criado para fortalecer o papel da mulher na sociedade angolana. Promove capacitação, inclusão social, empreendedorismo, autoestima e valorização da mulher.',
    desc_en: 'Female empowerment programme created to strengthen the role of women in Angolan society. Promotes training, social inclusion, entrepreneurship, self-esteem and women\'s valorisation.',
    category: 'women',
    color: 'pink',
    actions_pt: ['Formação profissional', 'Liderança feminina', 'Educação', 'Saúde da mulher', 'Inclusão económica', 'Direitos sociais'],
    actions_en: ['Professional training', 'Female leadership', 'Education', 'Women\'s health', 'Economic inclusion', 'Social rights'],
    areas_pt: ['Empoderamento Feminino', 'Educação', 'Saúde', 'Empreendedorismo'],
    areas_en: ['Female Empowerment', 'Education', 'Health', 'Entrepreneurship'],
  },
  {
    id: 'dikota',
    acronym: 'Dikota E6.0',
    title_pt: 'Dikota E6.0',
    title_en: 'Dikota E6.0',
    subtitle_pt: 'Inclusão social e valorização da pessoa idosa',
    subtitle_en: 'Social inclusion and valorisation of the elderly',
    desc_pt: 'Programa dedicado à valorização e inclusão social da pessoa idosa. Promove assistência social, cuidados de saúde, actividades de integração e valorização da experiência dos idosos na sociedade.',
    desc_en: 'Programme dedicated to the valorisation and social inclusion of the elderly. Promotes social assistance, healthcare, integration activities and valorisation of the elderly\'s experience in society.',
    category: 'social',
    color: 'amber',
    actions_pt: ['Envelhecimento digno', 'Combate ao isolamento', 'Inclusão social', 'Valorização da experiência', 'Assistência social e emocional'],
    actions_en: ['Dignified ageing', 'Fighting isolation', 'Social inclusion', 'Experience valorisation', 'Social and emotional assistance'],
    areas_pt: ['Assistência Social', 'Saúde', 'Inclusão Social'],
    areas_en: ['Social Assistance', 'Health', 'Social Inclusion'],
  },
  {
    id: 'campus',
    acronym: 'Campus',
    title_pt: 'Campus Juventude',
    title_en: 'Youth Campus',
    subtitle_pt: 'Capacitação, liderança e desenvolvimento da juventude',
    subtitle_en: 'Training, leadership and youth development',
    desc_pt: 'Programa voltado para capacitação, liderança e desenvolvimento da juventude angolana. Promove formação, empreendedorismo, cidadania e participação activa dos jovens no desenvolvimento social do país.',
    desc_en: 'Programme focused on training, leadership and development of Angolan youth. Promotes training, entrepreneurship, citizenship and active youth participation in social development.',
    category: 'youth',
    color: 'blue',
    actions_pt: ['Formação juvenil', 'Liderança', 'Inovação', 'Empreendedorismo', 'Desenvolvimento pessoal', 'Participação comunitária'],
    actions_en: ['Youth training', 'Leadership', 'Innovation', 'Entrepreneurship', 'Personal development', 'Community participation'],
    areas_pt: ['Juventude', 'Educação', 'Empreendedorismo', 'Liderança'],
    areas_en: ['Youth', 'Education', 'Entrepreneurship', 'Leadership'],
  },
  {
    id: 'revieng',
    acronym: 'Revieng',
    title_pt: 'Revieng Angola',
    title_en: 'Revieng Angola',
    subtitle_pt: 'Acções comunitárias e apoio humanitário directo',
    subtitle_en: 'Community actions and direct humanitarian support',
    desc_pt: 'Iniciativa social voltada para acções comunitárias e apoio humanitário. Desenvolve actividades de assistência social, solidariedade e apoio directo às famílias vulneráveis.',
    desc_en: 'Social initiative focused on community actions and humanitarian support. Develops social assistance activities, solidarity and direct support for vulnerable families.',
    category: 'emergency',
    color: 'emerald',
    actions_pt: ['Apoio social', 'Doações', 'Acções comunitárias', 'Campanhas solidárias', 'Assistência emergencial', 'Inclusão social'],
    actions_en: ['Social support', 'Donations', 'Community actions', 'Solidarity campaigns', 'Emergency assistance', 'Social inclusion'],
    areas_pt: ['Assistência Social', 'Emergência', 'Inclusão Social'],
    areas_en: ['Social Assistance', 'Emergency', 'Social Inclusion'],
  },
  {
    id: 'pe-boto',
    acronym: 'Pé Boto',
    title_pt: 'Cirurgias Ortopédicas – Pé Boto',
    title_en: 'Orthopaedic Surgery – Clubfoot',
    subtitle_pt: 'Acesso a tratamento especializado para crianças',
    subtitle_en: 'Access to specialised treatment for children',
    desc_pt: 'Programa de assistência médica especializada para crianças com deformidades ortopédicas, com destaque para o tratamento do pé boto. Garante acesso a consultas, cirurgias, acompanhamento médico e reabilitação.',
    desc_en: 'Specialised medical assistance programme for children with orthopaedic deformities, particularly clubfoot treatment. Guarantees access to consultations, surgeries, medical follow-up and rehabilitation.',
    category: 'health',
    color: 'violet',
    actions_pt: ['Consultas especializadas', 'Cirurgias ortopédicas', 'Acompanhamento médico', 'Reabilitação', 'Apoio às famílias'],
    actions_en: ['Specialised consultations', 'Orthopaedic surgeries', 'Medical follow-up', 'Rehabilitation', 'Family support'],
    areas_pt: ['Saúde', 'Crianças', 'Reabilitação'],
    areas_en: ['Health', 'Children', 'Rehabilitation'],
  },
];

export const timeline = [
  {
    year: '2020',
    title_pt: 'Fundação',
    title_en: 'Foundation',
    desc_pt: 'A Fundação Ngana Zenza é criada a 20 de Fevereiro, pela Primeira-Dama Ana Dias Lourenço, para promover o desenvolvimento sustentável das comunidades mais vulneráveis de Angola.',
    desc_en: 'The Ngana Zenza Foundation is created on 20 February by First Lady Ana Dias Lourenço, to promote sustainable development of Angola\'s most vulnerable communities.',
  },
  {
    year: '2020',
    title_pt: 'Primeiros Programas',
    title_en: 'First Programmes',
    desc_pt: 'Lançamento dos primeiros programas: Tata Uhayele (saúde), Seja Mulher (empoderamento feminino) e Geração Sem Sida até 2030.',
    desc_en: 'Launch of the first programmes: Tata Uhayele (health), Seja Mulher (female empowerment) and Generation Without AIDS by 2030.',
  },
  {
    year: '2021',
    title_pt: 'Dikota E6.0 e Campus Juventude',
    title_en: 'Dikota E6.0 and Youth Campus',
    desc_pt: 'Lançamento de dois novos programas dedicados aos idosos (Dikota E6.0) e à juventude angolana (Campus Juventude).',
    desc_en: 'Launch of two new programmes dedicated to the elderly (Dikota E6.0) and Angolan youth (Youth Campus).',
  },
  {
    year: '2021',
    title_pt: 'Revieng Angola',
    title_en: 'Revieng Angola',
    desc_pt: 'Criação do Revieng Angola para resposta humanitária directa e acções de solidariedade comunitária.',
    desc_en: 'Creation of Revieng Angola for direct humanitarian response and community solidarity actions.',
  },
  {
    year: '2022',
    title_pt: 'PDIC – Projecto Piloto Toco',
    title_en: 'PDIC – Toco Pilot Project',
    desc_pt: 'Lançamento do Programa de Desenvolvimento Integrado Comunitário na comunidade do Toco, Huíla. Um modelo transformador de desenvolvimento participativo.',
    desc_en: 'Launch of the Integrated Community Development Programme in the Toco community, Huíla. A transformative model of participatory development.',
  },
  {
    year: '2022',
    title_pt: 'Cirurgias Pé Boto',
    title_en: 'Clubfoot Surgeries',
    desc_pt: 'Início do programa de cirurgias ortopédicas para crianças com pé boto, garantindo reabilitação e nova esperança para famílias angolanas.',
    desc_en: 'Start of the orthopaedic surgery programme for children with clubfoot, ensuring rehabilitation and new hope for Angolan families.',
  },
  {
    year: '2023',
    title_pt: 'Expansão Nacional',
    title_en: 'National Expansion',
    desc_pt: 'Os programas da Fundação alcançam múltiplas províncias angolanas, ampliando significativamente o impacto das acções.',
    desc_en: 'The Foundation\'s programmes reach multiple Angolan provinces, significantly expanding the impact of actions.',
  },
  {
    year: '2024',
    title_pt: 'Consolidação e Crescimento',
    title_en: 'Consolidation and Growth',
    desc_pt: 'A Fundação consolida todos os programas, amplia parcerias estratégicas e prepara a estratégia de crescimento para 2025.',
    desc_en: 'The Foundation consolidates all programmes, expands strategic partnerships and prepares the growth strategy for 2025.',
  },
];

export const team = [
  {
    name: 'Ana Dias Lourenço',
    role_pt: 'Fundadora e Presidente de Honra',
    role_en: 'Founder and Honorary President',
    bio_pt: 'Primeira-Dama da República de Angola. Fundou a Fundação Ngana Zenza a 20 de Fevereiro de 2020, com o objectivo de promover o desenvolvimento sustentável das comunidades mais vulneráveis de Angola.',
    bio_en: 'First Lady of the Republic of Angola. Founded the Ngana Zenza Foundation on 20 February 2020, with the aim of promoting sustainable development of Angola\'s most vulnerable communities.',
    initials: 'AL',
    isFounder: true,
  },
];

export const partners = [
  { name: 'Governo de Angola', abbr: 'GovAO' },
  { name: 'UNICEF Angola', abbr: 'UNICEF' },
  { name: 'Ministério da Saúde', abbr: 'MINSA' },
  { name: 'Ministério da Educação', abbr: 'MED' },
  { name: 'União Europeia', abbr: 'EU' },
  { name: 'OMS Angola', abbr: 'WHO' },
  { name: 'UNFPA', abbr: 'UNFPA' },
  { name: 'Cruz Vermelha', abbr: 'ICRC' },
];

export const testimonials = [
  {
    name: 'Maria da Conceição',
    location_pt: 'Toco, Huíla',
    location_en: 'Toco, Huíla',
    text_pt: 'Graças ao PDIC, a nossa comunidade tem agora água potável, uma escola reabilitada e assistência médica regular. O Toco mudou completamente.',
    text_en: 'Thanks to the PDIC, our community now has clean water, a rehabilitated school and regular medical assistance. Toco has changed completely.',
  },
  {
    name: 'Carla Mendonça',
    location_pt: 'Luanda',
    location_en: 'Luanda',
    text_pt: 'O programa Seja Mulher deu-me formação, confiança e as ferramentas para criar o meu próprio negócio. Hoje sou independente e inspiração para outras mulheres.',
    text_en: 'The Seja Mulher programme gave me training, confidence and the tools to create my own business. Today I am independent and an inspiration to other women.',
  },
  {
    name: 'Tomás Simões',
    location_pt: 'Malanje',
    location_en: 'Malanje',
    text_pt: 'O meu filho nasceu com pé boto. Graças ao programa da Fundação, ele foi operado e hoje corre e brinca como qualquer criança. É um milagre.',
    text_en: 'My son was born with clubfoot. Thanks to the Foundation\'s programme, he had surgery and today he runs and plays like any child. It is a miracle.',
  },
];

export const galleryPhotos = [
  { id: 1,  cat: 'community', src: 'https://jpumokwyaqpqmqubhaep.supabase.co/storage/v1/object/public/franstel_armazenamento/fotos%20pdic/_DSC9047.JPG',    caption_pt: 'PDIC – Comunidade do Toco, Huíla',   caption_en: 'PDIC – Toco Community, Huíla',      size: 'lg' },
  { id: 2,  cat: 'health',    src: 'https://jpumokwyaqpqmqubhaep.supabase.co/storage/v1/object/public/franstel_armazenamento/FOTOS%20TATA%20UHAYELE/01.jpg', caption_pt: 'Tata Uhayele – Rastreio Médico',    caption_en: 'Tata Uhayele – Medical Screening', size: 'sm' },
  { id: 3,  cat: 'community', src: 'https://jpumokwyaqpqmqubhaep.supabase.co/storage/v1/object/public/franstel_armazenamento/img_fdc/11.jpg.jpeg',         caption_pt: 'Fundação em Acção',                 caption_en: 'Foundation in Action',             size: 'sm' },
  { id: 4,  cat: 'community', src: 'https://jpumokwyaqpqmqubhaep.supabase.co/storage/v1/object/public/franstel_armazenamento/fotos%20pdic/_DSC9067.JPG',    caption_pt: 'PDIC – Actividade Comunitária',    caption_en: 'PDIC – Community Activity',        size: 'md' },
  { id: 5,  cat: 'health',    src: 'https://jpumokwyaqpqmqubhaep.supabase.co/storage/v1/object/public/franstel_armazenamento/FOTOS%20TATA%20UHAYELE/02.jpg', caption_pt: 'Tata Uhayele – Assistência Médica', caption_en: 'Tata Uhayele – Medical Assistance', size: 'md' },
  { id: 6,  cat: 'community', src: 'https://jpumokwyaqpqmqubhaep.supabase.co/storage/v1/object/public/franstel_armazenamento/img_fdc/D%20(2).jpg',          caption_pt: 'Apoio Comunitário',                 caption_en: 'Community Support',                size: 'sm' },
  { id: 7,  cat: 'community', src: 'https://jpumokwyaqpqmqubhaep.supabase.co/storage/v1/object/public/franstel_armazenamento/img_fdc/DD.jpg',               caption_pt: 'Transformação Social',              caption_en: 'Social Transformation',            size: 'sm' },
  { id: 8,  cat: 'community', src: 'https://jpumokwyaqpqmqubhaep.supabase.co/storage/v1/object/public/franstel_armazenamento/fotos%20pdic/_DSC9090.JPG',    caption_pt: 'PDIC – Infra-estruturas',           caption_en: 'PDIC – Infrastructure',            size: 'md' },
  { id: 9,  cat: 'community', src: 'https://jpumokwyaqpqmqubhaep.supabase.co/storage/v1/object/public/franstel_armazenamento/fotos%20pdic/_DSC9449_1.JPG',  caption_pt: 'PDIC – Agricultura Sustentável',   caption_en: 'PDIC – Sustainable Agriculture',   size: 'md' },
  { id: 10, cat: 'health',    src: 'https://jpumokwyaqpqmqubhaep.supabase.co/storage/v1/object/public/franstel_armazenamento/FOTOS%20TATA%20UHAYELE/03.jpg', caption_pt: 'Tata Uhayele – Saúde Comunitária', caption_en: 'Tata Uhayele – Community Health',  size: 'lg' },
  { id: 11, cat: 'community', src: 'https://jpumokwyaqpqmqubhaep.supabase.co/storage/v1/object/public/franstel_armazenamento/fotos%20pdic/_DSC9454_1.JPG',  caption_pt: 'PDIC – Formação Técnica',           caption_en: 'PDIC – Technical Training',        size: 'sm' },
  { id: 12, cat: 'community', src: 'https://jpumokwyaqpqmqubhaep.supabase.co/storage/v1/object/public/franstel_armazenamento/fotos%20pdic/_DSC9456_1.JPG',  caption_pt: 'PDIC – Desenvolvimento Local',     caption_en: 'PDIC – Local Development',         size: 'sm' },
];

export const videos = [
  {
    id: 'v1',
    src: 'https://drive.google.com/file/d/1gLFqxBmceWX4I1FQET91hIEsog4UnIg5/view',
    title_pt: 'Fundação Ngana Zenza — Filme Institucional',
    title_en: 'Ngana Zenza Foundation — Institutional Film',
    desc_pt: 'Conheça a missão, os programas e o impacto da Fundação nas comunidades angolanas.',
    desc_en: 'Discover the Foundation\'s mission, programmes and impact on Angolan communities.',
    duration: '',
  },
  {
    id: 'v2',
    src: 'https://drive.google.com/file/d/1A7sa8eMcaChOaXx7cNZs1n7chPPWOOGU/view',
    title_pt: 'PDIC – Comunidade do Toco, Huíla',
    title_en: 'PDIC – Toco Community, Huíla',
    desc_pt: 'O programa de desenvolvimento integrado comunitário e a sua transformação na comunidade do Toco.',
    desc_en: 'The integrated community development programme and its transformation in the Toco community.',
    duration: '',
  },
  {
    id: 'v3',
    src: 'https://drive.google.com/file/d/1jOCjTVXPzbt--ZC5HyP_1jDnyK3rcPOt/view',
    title_pt: 'Tata Uhayele — Saúde para Todos',
    title_en: 'Tata Uhayele — Health for All',
    desc_pt: 'Assistência médica a comunidades remotas: o impacto do programa Tata Uhayele.',
    desc_en: 'Medical assistance to remote communities: the impact of the Tata Uhayele programme.',
    duration: '',
  },
  {
    id: 'v4',
    src: 'https://drive.google.com/file/d/1XiZtmOL6n30bWcCPjRnpSU6oNzA-Z1Y-/view',
    title_pt: 'Tata Uhayele — Acções no Terreno',
    title_en: 'Tata Uhayele — Field Actions',
    desc_pt: 'As acções de saúde comunitária do programa Tata Uhayele em Angola.',
    desc_en: 'Community health actions of the Tata Uhayele programme in Angola.',
    duration: '',
  },
  {
    id: 'v5',
    src: 'https://drive.google.com/file/d/1X6PSqu4yFAXwNSD56hdAtzK2QN45qmxX/view',
    title_pt: 'Fundação Ngana Zenza — Impacto nas Comunidades',
    title_en: 'Ngana Zenza Foundation — Community Impact',
    desc_pt: 'Um olhar sobre o trabalho da Fundação Ngana Zenza nas comunidades angolanas.',
    desc_en: 'A look at the work of the Ngana Zenza Foundation in Angolan communities.',
    duration: '',
  },
];
